import React, { useState, useEffect, useCallback } from 'react';
import { listDevices, mintDevice, revokeDevice } from '../../lib/assessment-kiosk-admin-api';

export function FacilityDevices({ facilityId }) {
  const [devices, setDevices] = useState([]);
  const [newKey, setNewKey] = useState(null); // shown once after mint
  const [label, setLabel] = useState('');
  const [minting, setMinting] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    try {
      const res = await listDevices(facilityId);
      setDevices(res.devices || res || []);
    } catch (e) { setError(e.message); }
  }, [facilityId]);

  useEffect(() => { load(); }, [load]);

  async function onMint() {
    if (minting) return;
    if (!label.trim()) { setError('Enter a device label first.'); return; }
    setError(null); setMinting(true);
    try {
      const res = await mintDevice(facilityId, label.trim());
      // Raw key is returned once; never fetched again from server.
      setNewKey({ label: label.trim(), key: res.key });
      setLabel('');
      await load();
    } catch (e) { setError(e.message); }
    finally { setMinting(false); }
  }

  async function onRevoke(did) {
    if (!window.confirm('Revoke this device key? The kiosk using it will stop working immediately.')) return;
    setError(null);
    try { await revokeDevice(facilityId, did); await load(); }
    catch (e) { setError(e.message); }
  }

  return (
    <div className="kiosk-subsection">
      <h4>Devices</h4>
      {error && <div className="kiosk-admin-error">{error}</div>}

      {newKey && (
        <div className="kiosk-new-key">
          <strong>New device key for "{newKey.label}" — save it now, it will not be shown again:</strong>
          <code className="kiosk-key-box">{newKey.key}</code>
          <button className="btn sm" onClick={() => navigator.clipboard?.writeText(newKey.key)}>Copy</button>
          <button className="btn ghost sm" onClick={() => setNewKey(null)}>Dismiss</button>
        </div>
      )}

      <div className="kiosk-add-device">
        <input type="text" placeholder="Device label (e.g., Group home iPad)" value={label}
          onChange={(e) => setLabel(e.target.value)} maxLength={100} />
        <button className="btn sm" disabled={minting} onClick={onMint}>
          {minting ? 'Adding…' : 'Add device'}
        </button>
      </div>

      <table className="kiosk-device-table">
        <thead><tr><th>Label</th><th>Prefix</th><th>Created</th><th></th></tr></thead>
        <tbody>
          {devices.length === 0 && (
            <tr><td colSpan={4} className="kiosk-empty">No devices yet.</td></tr>
          )}
          {devices.map((d) => (
            <tr key={d.id} className={d.revoked_at ? 'kiosk-revoked' : ''}>
              <td>{d.label}</td>
              <td className="tabnum">{d.key_prefix}…</td>
              <td className="tabnum">{d.created_at ? new Date(d.created_at).toLocaleDateString() : ''}</td>
              <td>
                {d.revoked_at
                  ? <em>revoked</em>
                  : <button className="btn ghost sm" onClick={() => onRevoke(d.id)}>Revoke</button>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
